import { addStyling } from '@plone/volto/helpers';
import config from '@plone/volto/registry';

import alignTopSVG from '@plone/volto/icons/move-up.svg';
import alignCenterSVG from '@plone/volto/icons/row.svg';
import alignBottomSVG from '@plone/volto/icons/move-down.svg';
import clearSVG from '@plone/volto/icons/clear.svg';

const ALIGN_INFO_MAP = {
  'has--bg--top': [alignTopSVG, 'Top'],
  'has--bg--center': [alignCenterSVG, 'Center'],
  'has--bg--bottom': [alignBottomSVG, 'Bottom'],
  '': [clearSVG, 'None'],
};

export const HeroBlockSchema = () => {
  return {
    title: 'Hero',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'fullWidth',
          'fullHeight',
          'quoted',
          'spaced',
          'inverted',
          'isMultiline',
          'buttonLabel',
          'buttonLink',
          'overlay',
          'image',
        ],
      },
      {
        id: 'copyright',
        title: 'Urheberrecht',
        fields: ['copyright', 'copyrightIcon', 'copyrightPosition'],
      },
    ],
    properties: {
      fullWidth: {
        title: 'Ganze Breite',
        type: 'boolean',
        defaultValue: true,
      },
      fullHeight: {
        title: 'Ganze Höhe',
        type: 'boolean',
        defaultValue: true,
      },
      quoted: {
        title: 'Zitat',
        type: 'boolean',
        defaultValue: false,
      },
      spaced: {
        title: 'Abstand',
        type: 'boolean',
        defaultValue: false,
      },
      inverted: {
        title: 'Umgekehrt',
        type: 'boolean',
        defaultValue: true,
      },
      isMultiline: {
        title: 'Mehrzeilig',
        type: 'boolean',
        defaultValue: false,
      },
      buttonLabel: {
        title: 'Button Name',
        widget: 'textarea',
      },
      buttonLink: {
        title: 'Button Link',
        widget: 'url',
      },
      overlay: {
        title: 'Bild abdunkeln',
        type: 'boolean',
        defaultValue: true,
      },
      image: {
        title: 'Bild',
        widget: 'attachedimage',
      },
      copyright: {
        title: 'Text',
      },
      copyrightIcon: {
        title: 'Icon',
        description: (
          <>
            Bsp. ri-copyright-line. Siehe{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://remixicon.com/"
            >
              Remix Icon Set
            </a>
          </>
        ),
        default: 'ri-copyright-line',
      },
      copyrightPosition: {
        title: 'Ausrichtung',
        widget: 'align',
        actions: ['left', 'right'],
        defaultValue: 'left',
      },
    },
    required: [],
  };
};

export const stylingSchema = (props) => {
  const schema = addStyling(props);
  schema.properties.styles.schema = {
    title: 'Hero style',
    block: 'hero',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'backgroundVariant',
          'bg',
          'alignContent',
          'textAlign',
          'textVariant',
          'buttonVariant',
          'buttonAlign',
        ],
      },
    ],
    properties: {
      bg: {
        title: 'Position des Hintergrundbildes',
        widget: 'align',
        actions: Object.keys(ALIGN_INFO_MAP),
        actionsInfoMap: ALIGN_INFO_MAP,
        defaultValue: 'has--bg--center',
      },
      backgroundVariant: {
        title: 'Hintergrund Gestaltungsoptionen',
        widget: 'theme_picker',
        colors: [
          ...(config.settings && config.settings.themeColors
            ? config.settings.themeColors.map(({ value, title }) => ({
              name: value,
              label: title,
            }))
            : []),
          //and add extra ones here
        ],
      },
      alignContent: {
        title: 'Inhalt ausrichtung',
        choices: [
          ['start', 'Oben'],
          ['center', 'Mitte'],
          ['end', 'Unten'],
        ],
      },
      textAlign: {
        title: 'Text ausrichtung',
        widget: 'align',
        actions: ['left', 'center', 'right'],
        defaultValue: 'left',
      },
      textVariant: {
        title: 'Text Gestaltungsoptionen',
        widget: 'theme_picker',
        colors: [
          ...(config.settings && config.settings.themeColors
            ? config.settings.themeColors.map(({ value, title }) => ({
              name: value,
              label: title,
            }))
            : []),
          //and add extra ones here
        ],
      },
      buttonVariant: {
        title: 'Button Gestaltungsoptionen',
        widget: 'theme_picker',
        colors: [
          ...(config.settings && config.settings.themeColors
            ? config.settings.themeColors.map(({ value, title }) => ({
              name: value,
              label: title,
            }))
            : []),
          //and add extra ones here
        ],
      },
      buttonAlign: {
        title: 'Button ausrichtung',
        widget: 'align',
        actions: ['left', 'center', 'right'],
        defaultValue: 'left',
      },
    },
    required: [],
  };
  return schema;
};